import { Gender } from '@/types/schema.generated'

export type DiagnosisType = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8

export type PersonalityType = 'A' | 'B' | 'C' | 'D' | 'E' | 'F' | 'G' | 'H'

export type DiagnosisResult = {
  personality: Personality
}

export type Personality = {
  type: PersonalityType
  title: string
  description: string
}

export type Sex = 'male' | 'female' | 'noAnswer'
const genderMap: { [K in Sex]: Gender } = {
  male: Gender.Male,
  female: Gender.Female,
  noAnswer: Gender.NoAnswer,
} as const

export const convertSexToGqlGender = (sex: Sex): Gender => genderMap[sex]

const sexMap: { [K in Gender]: Sex } = {
  MALE: 'male',
  FEMALE: 'female',
  NO_ANSWER: 'noAnswer',
  OTHER: 'noAnswer', // FIXME: Otherは現状選べないのでnoAnswerにしている
}

export const convertGqlGenderToSex = (gender: Gender): Sex => sexMap[gender]

export type Child = {
  sex: Sex
  age: number
}

export type Rank = 'A' | 'B' | 'C' | 'D' | 'E'

export type DiagnosisAnalysisItem<
  RankType extends Rank | undefined,
  UnitType extends '万円' | '円',
> = {
  title: string
  rank: RankType
  userValue: number
  averageValue: number
  unit: UnitType
  message: string
}

export type DiagnosisAnalysis = {
  annualIncome: DiagnosisAnalysisItem<Rank, '万円'>
  annualSaving: DiagnosisAnalysisItem<Rank, '万円'>
  monthlyRentCost: DiagnosisAnalysisItem<Rank, '万円'>
  investment: DiagnosisAnalysisItem<undefined, '万円'>
  monthlyInsurance: DiagnosisAnalysisItem<undefined, '円'>
}
export type ConcreteDiagnosisAnalysisItem =
  DiagnosisAnalysis[keyof DiagnosisAnalysis]

export type DiagnosisSummary = {
  analysis: DiagnosisAnalysis
  result: DiagnosisResult
}

export type DiagnosisInputContents = {
  sex: Sex
  prefecture: string
  yearOfbirth: number
  saving: number
  annualIncome: number
  savingMonth: number
  monthlyRentCost: number
  hasChild: boolean
  children: Child[]
  monthlyInsurance: number
  investment: number
  hasPartner: boolean
  partnerYearOfBirth: Maybe<number>
  partnerAnnualIncome: Maybe<number>
  loanBalance: Maybe<number> // 途中から追加された項目なのでない可能性がある
  job: Maybe<string> // 途中から追加された項目なのでない可能性がある
}
